import { ChatModel, TabOption } from '@/types';
import { CgMonday, FaSalesforce } from '@components/Icon';

const API_URL = process.env.NEXT_PUBLIC_API_URL;
const MAX_FILE_SIZE_MB = 20;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_FILES = 3;
const ALLOWED_FILE_TYPES = ['pdf', 'csv', 'txt', 'docx'];

const CHAT_TYPES = {
  USER: 'user',
  BOT: 'bot',
};

const LOGOUT_TYPE = [
  { key: 'salesforce', value: 'Salesforce', icon: FaSalesforce },
  { key: 'monday', value: 'Monday.com', icon: CgMonday },
];

const CHAT_OPTION: TabOption[] = [
  {
    label: 'Tool Calling',
    value: 'tool',
  },
  {
    label: 'General Chat',
    value: 'general',
  },
] as const;

const LLM: { label: string; value: ChatModel }[] = [
  {
    label: 'OpenAI',
    value: 'openai',
  },
  {
    label: 'Perplexity',
    value: 'perplexity',
  },
] as const;

export {
  API_URL,
  CHAT_OPTION,
  CHAT_TYPES,
  LLM,
  LOGOUT_TYPE,
  MAX_FILE_SIZE_BYTES,
  MAX_FILES,
  MAX_FILE_SIZE_MB,
  ALLOWED_FILE_TYPES,
};
